import React from "react";
import { adjacentIndexes } from "../utils/deck";
import { useHorizontalDeck } from "../hooks/useHorizontalDeck";
import { AddWorkspaceCard } from "./AddWorkspaceCard";
import { WorkspaceCard } from "./WorkspaceCard";
import { WorkspacePeek } from "./WorkspacePeek";

export function HorizontalWorkspaceDeck({ workspaces, role, onUpdate, onAction, onAddWorkspace }) {
  const deck = useHorizontalDeck({ itemCount: workspaces.length });
  const indexes = adjacentIndexes(deck.activeIndex, workspaces.length);
  const activeWorkspace = workspaces[indexes.active];

  return (
    <section
      className="lw-deck"
      aria-roledescription="carousel"
      aria-label="Workspaces"
      tabIndex="0"
      {...deck.interactionProps}
    >
      <div className="lw-deck__status" aria-live="polite">
        <span>{deck.activeIndex + 1} / {workspaces.length}</span>
        <span>{activeWorkspace.title}</span>
        <small>Drag, scroll, swipe, or use arrow keys</small>
      </div>

      <div className="lw-deck__cards">
        <WorkspacePeek workspace={workspaces[indexes.previous]} direction="previous" onSelect={deck.previous} />
        <div className="lw-deck__active">
          {activeWorkspace.kind === "add" ? (
            <AddWorkspaceCard workspace={activeWorkspace} role={role} onAdd={onAddWorkspace} />
          ) : (
            <WorkspaceCard workspace={activeWorkspace} role={role} onUpdate={onUpdate} onAction={onAction} />
          )}
        </div>
        <WorkspacePeek workspace={workspaces[indexes.next]} direction="next" onSelect={deck.next} />
      </div>

      <nav className="lw-deck__nav" aria-label="Choose workspace">
        {workspaces.map((workspace, index) => (
          <button
            type="button"
            key={workspace.id}
            aria-label={`Go to ${workspace.title}`}
            aria-current={index === deck.activeIndex ? "true" : undefined}
            onClick={() => deck.goTo(index)}
          >
            <span />
            <small>{workspace.title}</small>
          </button>
        ))}
      </nav>
    </section>
  );
}
